import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { Link } from "react-router-dom";
import axios from "axios";
import Authorize from "../../../global/Authorize";
import Skeleton from "react-loading-skeleton";
import ClassAtt from "./ClassAtt";

class Attendancep extends Component {
  state = {
    fakeData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    loading: true,
    currentTab: 1,
    class: [],
    date: `${new Date().getFullYear()}-${
      (new Date().getMonth() + 1 < 10 ? "0" : "") + (new Date().getMonth() + 1)
    }-${(new Date().getDate() < 10 ? "0" : "") + new Date().getDate()}`,
  };
  componentDidMount = () => {
    this.fetchClass();
  };
  fetchClass = () => {
    axios
      .get("/api/class")
      .then((res) => {
        this.setState({ class: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <Authorize roles={["IS_PRINCIPAL"]} redirect to="/">
        <Header to="/home" title="Attendance" />
        <div>
          {/* Tabs Start */}
          <div className="shadow-sm mb-2 row">
            <div
              className={
                this.state.currentTab === 1
                  ? "col-4 text-center th-cap th-12 py-2 border-bottom th-border mx-auto"
                  : "col-4 text-center th-cap th-12 py-2 mx-auto"
              }
              onClick={() => this.setState({ currentTab: 1 })}
            >
              <div
                className={
                  this.state.currentTab === 1 ? "th-primary" : "th-black"
                }
              >
                VIEW
              </div>
            </div>
            <div
              className={
                this.state.currentTab === 2
                  ? "col-4 text-center th-cap th-12 py-2 border-bottom th-border mx-auto"
                  : "col-4 text-center th-cap th-12 py-2 mx-auto"
              }
              onClick={() => this.setState({ currentTab: 2 })}
            >
              <div
                className={
                  this.state.currentTab === 2 ? "th-primary" : "th-black"
                }
              >
                OVERVIEW
              </div>
            </div>
          </div>
          {/* Tabs end */}

          {/* Layout Rendered */}
          <div className="container">
            {this.state.loading ? (
              <div className="d-flex flex-wrap">
                {this.state.fakeData?.map((item, index) => {
                  return (
                    <div key={index} className="col-6 px-1">
                      <div className="btn mt-2 border rounded btn-block p-1">
                        <Skeleton />
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}

            {this.state.class?.length !== 0 && this.state.loading === false ? (
              <div className="d-flex flex-wrap">
                {this.state.currentTab === 0
                  ? this.state.class?.map((classs) =>
                      classs.section?.map((section) => (
                        <div className="col-6 px-1">
                          <Link
                            type="button"
                            className="btn mt-2 th-att-btn btn-block"
                            to={`/markAtt/${classs.id}/${classs.class_name}/${section.id}/${section.section_name}/${this.state.date}`}
                          >
                            {classs.class_name} | {section.section_name}
                          </Link>
                        </div>
                      ))
                    )
                  : null}
                {this.state.currentTab === 1
                  ? this.state.class?.map((classs) =>
                      classs.section?.map((section) => (
                        <div className="col-6 px-1">
                          <Link
                            type="button"
                            className="btn mt-2 th-att-btn btn-block"
                            to={`/viewAtt/${classs.id}/${classs.class_name}/${section.id}/${section.section_name}/${this.state.date}`}
                          >
                            {classs.class_name} | {section.section_name}
                          </Link>
                        </div>
                      ))
                    )
                  : null}
                {this.state.currentTab === 2 ? <ClassAtt /> : null}
              </div>
            ) : null}
          </div>
          {/* Layout Rendered ends*/}
        </div>
      </Authorize>
    );
  }
}
export default Attendancep;
